import React from 'react';
import TopFold from './components/TopFold/TopFold';
import IntroOverlay from './components/IntroOverlay/IntroOverlay';
import MissionVision from './components/MissionVision/MissionVision';
import WhyUs from './components/WhyUs/WhyUs';
import Projects from './components/Projects';
import Services from './components/Services';
import Facts from './components/Facts';
import Partners from './components/Facts/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './HomePage.css';
import { useLanguage } from '../../context/LanguageContext';

const HomePage = () => {
  const { direction } = useLanguage();

  return (
    <main className={`home-page ${direction === 'rtl' ? 'rtl' : ''}`}>
      <IntroOverlay />
      <TopFold />
      <Projects />
      <MissionVision />
      <WhyUs />
      <Services />
      <Facts />
      <Partners />
      <Contact />
      <Footer />

      {/* Other sections will be added here */}
    </main>
  );
};

export default HomePage; 